<template functional>
  <div
    :class="data.staticClass"
    :style="{ backgroundColor: props.child ? props.child.color : '#C9B5AA' }"
    class="ChildAvatar"
    v-bind="{...data.attrs, [parent.$options._scopeId]: ''}"
    v-on="listeners"
  >
    <div class="img-wrap" :class="{ 'is-hidden': !(props.child && props.child.genderKey === 'boy') }">
      <img src="/images/avatar/boy.png" alt="">
    </div>
    <div class="img-wrap" :class="{ 'is-hidden': !(props.child && props.child.genderKey === 'girl') }">
      <img src="/images/avatar/girl.png" alt="">
    </div>
    <div class="img-wrap" :class="{ 'is-hidden': props.child }">
      <img src="/images/avatar/parent.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChildAvatar',
  props: {
    child: {},
  },
}
</script>

<style scoped lang="scss">
$size: 95%;
$padding: (100% - $size) / 2;

.ChildAvatar {
  position: relative;
  overflow: hidden;
  transition: background-color 0.6s ease;
  border-radius: 50%;

  &::before {
    display: block;
    padding-top: 100%;
    content: '';
  }
}

.img-wrap {
  position: absolute;
  top: $padding;
  left: $padding;
  width: $size;
  height: $size;
  transition: all 0.5s ease;

  &.is-hidden {
    transform: scale(0);
    opacity: 0;
  }

  img {
    width: 100%;
  }
}
</style>
